import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
// api
import { getSingleCoverLevelData } from '../api';
// react router
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// hooks
import useSettings from '@/hooks/useSettings';
// components
import { Page, HeaderBreadcrumbs } from '@/components';
// custom components
import CoverTypeCreateEdit from './CoverTypeCreateEdit';
// types
import type { CoverType } from '../types';
// paths
import { PATH_USER } from '@/features/app';
import { PATH_SETTINGS } from '../routes/paths';

// ----------------------------------------------------------------------

export default function ActivityTypesCreate() {
  const { themeStretch } = useSettings();
  const [currentData, setCurrentData] = useState<CoverType | {}>({});

  const { pathname } = useLocation();

  const { id } = useParams();

  const isEdit = pathname.includes('edit');

  useEffect(() => {
    const fetchData = async () => {
      const data = await getSingleCoverLevelData(Number(id));
      setCurrentData(data);
    };

    id && fetchData();
  }, [id]);

  return (
    <Page title="Create or Edit cover level type">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={!isEdit ? 'Add cover level type' : 'Edit cover level type'}
          links={[
            { name: 'Dashboard', href: PATH_USER.root },
            {
              name: 'Settings',
              href: `${PATH_SETTINGS.root}${PATH_SETTINGS.coverLevel}`,
            },
            {
              name: 'Cover Level Types',
              href: `${PATH_SETTINGS.root}${PATH_SETTINGS.coverLevel}`,
            },
            {
              name: !isEdit
                ? 'Add New Type'
                : isEmpty(currentData)
                ? ''
                : (currentData as CoverType).name,
            },
          ]}
        />
        <CoverTypeCreateEdit
          currentData={currentData as CoverType}
          ID={Number(id)}
        />
      </Container>
    </Page>
  );
}
